import { createCrudSlice } from '../../../../data/store/create-crud-slice';
import CaseInfo from './CaseInfo';

const caseInfoSlice = createCrudSlice<CaseInfo>('caseInfo');
export const { removeItem, createItem, updateItem, setItems } = caseInfoSlice.actions;

export default caseInfoSlice;